import React, { Suspense, lazy } from "react";
import { MODALIDADES_ACESSO } from "../components/modalidades/permissoesModalidades";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
// Liga/desliga do CRM por portal (servicoshabilitados/{portal}.servicos.crm) — rota de layout.
import GuardaModuloCrm from "../components/crm/GuardaModuloCrm";
import ExigirTrocaDeSenha from "../components/seguranca/ExigirTrocaDeSenha";
import Layout from "../pages/Layout";
// import CredencialCheckPage from "../pages/eventos/credenciamento/CredencialCheckPage";
// import LocalizacaoPage from "../pages/eventos/credenciamento/LocalizacaoPage";
// import PesagemPage from "../pages/eventos/pesagem/PesagemPage";
// import CertificatePage from "../pages/services/CertificatePage";
// import CredenciaisPage from "../pages/eventos/credenciais/CredenciaisPage";
// import NoticiasPageVersion2 from "../pages/noticias/NoticiasPageVersion2";
// import CredencialPage from "../pages/eventos/credenciamento/CredencialPage";
// import VirtualCredencialComponent from "../pages/eventos/credenciais/VirtualCredencialComponent";
// import ExcelImportPage from "../pages/eventos/ExcelImportPage";
// import CarterinhasPage from "../pages/services/carterinhas/CarteirinhasPage";
// import CarteirinhaCertificatePage from "../pages/services/carterinhas/CarteirinhaCertificatePage";
import { REBALANCEAMENTO_ACESSO } from "../constants/eventos/chaves/permissoesRebalanceamento";
import {
  CHAVES_ACESSO,
  CHAVES_OPERAR,
} from "../constants/eventos/chaves/permissoesChaves";

const ForgotPasswordPage = lazy(() => import("../pages/security/ForgotPasswordPage"));
const ResetPasswordConfirmPage = lazy(() => import("../pages/security/ResetPasswordConfirmPage"));
const HomePage = lazy(() => import("../pages/HomePage"));
// const HomeFederacaoPage = lazy(() => import("../pages/HomeFederacao")); 
const LoginPage = lazy(() => import("../pages/security/LoginPage"));
const NotFoundPage = lazy(() => import("../pages/error/NotFoundPage"));
const TestLazyPage = lazy(() => import("../pages/TestLazyPage"));
const PrivacyPoliticsPage = lazy(() => import("../pages/PrivacyPoliticsPage"));
const ProfilePage = lazy(() => import("../pages/ProfilePage"));
// const SignupPage = lazy(() => import("../pages/security/SignupPage"));
const ChangePasswordPage = lazy(() => import("../pages/security/ChangePasswordPage"));
const ChangeEmailPage = lazy(() => import("../pages/security/ChangeEmailPage"));
const ChangeNamePage = lazy(() => import("../pages/security/ChangeNamePage"));
const UnauthorizedPage = lazy(() => import("../pages/error/UnauthorizedPage"));
const ModuloIndisponivelPage = lazy(() => import("../pages/error/ModuloIndisponivelPage"));
const NotVerifiedPage = lazy(() => import("../pages/security/NotVerfiedPage"));

// Páginas Administrativas
// const AdminDashboard = lazy(() => import("../pages/admin/AdminDashboard")); // REMOVIDO - usando AdminPanel
const DeploySecurityRules = lazy(() => import("../components/admin/DeploySecurityRules/DeploySecurityRules"));
const SystemLogsPage = lazy(() => import("../pages/admin/SystemLogsPage"));
const SecurityRulesPage = lazy(() => import("../pages/admin/SecurityRulesPage"));
const SecurityGroupsPage = lazy(() => import("../pages/admin/SecurityGroupsPage"));
const SystemConfigPage = lazy(() => import("../pages/admin/SystemConfigPage"));
const MaintenancePage = lazy(() => import("../pages/admin/MaintenancePage"));
const FinancialReportsPage = lazy(() => import("../pages/admin/FinancialReportsPage"));
const FinancialConfigPage = lazy(() => import("../pages/admin/FinancialConfigPage"));
const CPFNormalizationTool = lazy(() => import("../pages/admin/CPFNormalizationTool"));
const ExportacaoDivergenciasPage = lazy(() => import("../pages/admin/ExportacaoDivergenciasPage"));
const ExportacaoDesatualizadosPage = lazy(() => import("../pages/admin/ExportacaoDesatualizadosPage"));
const ExportacaoEntidadesFiliadosPage = lazy(() => import("../pages/admin/ExportacaoEntidadesFiliadosPage"));
const LimparAnexosDuplicados = lazy(() => import("../pages/admin/LimparAnexosDuplicados"));
const YearEndInventoryPage = lazy(() => import("../pages/admin/YearEndInventoryPage"));
const AcompanhamentoTarefasPage = lazy(() => import("../pages/admin/AcompanhamentoTarefasPage"));
const EstruturaTecnicaPage = lazy(() => import("../pages/admin/EstruturaTecnicaPage"));
const BatchTaxGenerationPage = lazy(() => import("../pages/admin/BatchTaxGenerationPage"));
const LancamentoTaxa1Dan2026Page = lazy(() => import("../pages/admin/LancamentoTaxa1Dan2026Page"));
const CorrigirContasSemNumeroPage = lazy(() => import("../pages/admin/CorrigirContasSemNumeroPage"));
const CriarInscritosV4Page = lazy(() => import("../pages/admin/CriarInscritosV4Page"));
const ComparacaoListasPraticantes = lazy(() => import("../pages/admin/ComparacaoListasPraticantes"));

const AddUsersGroupPage = lazy(() => import("../pages/security/UsersGroups/AddUsersGroupPage"));
const UsersGroupsPage = lazy(() => import("../pages/security/UsersGroups/UsersGroupsPage"));
const AddUserPage = lazy(() => import("../pages/security/users/AddUserPage"));
const UsersPage = lazy(() => import("../pages/security/users/UsersPage"));
// const VerifyEmailPage = lazy(() => import("../pages/security/VerifyEmailPage"));
const PraticantesPage = lazy(() => import("../pages/registers/praticantes/PraticantesPage"));
// const PraticantesPage = lazy(() => import("../pages/registers/praticantes/PraticantesPageV4"));
const AddPraticantesPage = lazy(() => import("../pages/registers/praticantes/AddPraticantesPage"));
const CacheCpfManualPage = lazy(() => import("../pages/admin/cache-cpf/CacheCpfManualPage"));
const AddContaPage = lazy(() => import("../pages/financial/AddContaPage"));
const ContasReceberPage = lazy(() => import("../pages/financial/receber/ContasReceberPage"));
const RelatorioReceitasUFPage = lazy(() => import("../pages/financial/receber/RelatorioReceitasUFPage"));
const ContasPagarPage = lazy(() => import("../pages/financial/pagar/ContasPagarPage"));
const PrintImagePage = lazy(() => import("../pages/PrintImagePage"));
const PrintReciboPage = lazy(() => import("../pages/financial/PrintReciboPage"));
const PrintFaturaPage = lazy(() => import("../pages/financial/PrintFaturaPage"));
const SieHomePage = lazy(() => import("../pages/sie/SieHomePage"));
const DashboardCertificadosColoridasPage = lazy(() => import("../pages/sie/DashboardCertificadosColoridasPage"));
const DashboardEmissaoCertificadosPage = lazy(() => import("../pages/sie/DashboardEmissaoCertificadosPage"));
const ReconciliarContadoresCertificadosPage = lazy(() => import("../pages/admin/ReconciliarContadoresCertificadosPage"));
const EditorNovidades = lazy(() => import("../pages/sie/EditorNovidades"));
const InstitucionalHomePage = lazy(() => import("../pages/institucional/InstitucionalHomePage"));
// const TransparenciaHomePage = lazy(() => import("../pages/transparencia/TransparenciaHomePage"));
const TransparenciaHomePage = lazy(() => import("../pages/transparencia/TransparenciaHomePageVersion2"));
const EducativoHomePage = lazy(() => import("../pages/educativo/EducativoHomePage"));
const CBTKDEducaHome = lazy(() => import("../pages/CBTKDeduca/CBTKDEducaHome"));
const VideoDetalhes = lazy(() => import("../pages/CBTKDeduca/VideoDetalhes"));
const PostagemDetalhes = lazy(() => import("../pages/CBTKDeduca/PostagemDetalhes"));
const CBTKDEducaAdmin = lazy(() => import("../pages/CBTKDeduca/Admin"));

// CBTKDeduca Classroom Components
const TurmasManager = lazy(() => import("../components/CBTKDeduca/Classroom/TurmasManager"));
const TurmaDetalhes = lazy(() => import("../components/CBTKDeduca/Classroom/TurmaDetalhes"));
const TurmaConfiguracoes = lazy(() => import("../components/CBTKDeduca/Classroom/TurmaConfiguracoes"));
const TarefaDetalhes = lazy(() => import("../components/CBTKDeduca/Classroom/TarefaDetalhes"));
const MaterialDetalhes = lazy(() => import("../components/CBTKDeduca/Classroom/MaterialDetalhes"));
const ProfessoresManager = lazy(() => import("../components/CBTKDeduca/Classroom/ProfessoresManager"));
const ProfessorPerfil = lazy(() => import("../components/CBTKDeduca/Classroom/ProfessorPerfil"));
const EntidadesPage = lazy(() => import("../pages/registers/entidades/EntidadesPage"));
const AddEntidadePage = lazy(() => import("../pages/registers/entidades/AddEntidadePage"));
const ServicesPage = lazy(() => import("../pages/services/taxas/TaxasPage"));
const AddServicePage = lazy(() => import("../pages/services/taxas/AddServicePage"));
const WizardTaxaPage = lazy(() => import("../pages/services/taxas/WizardTaxaPage"));
const ImportTaxasPage = lazy(() => import("../pages/services/taxas/ImportTaxasPage"));
const CertificationsPage = lazy(() => import("../pages/certificados/CertificationPage"));
const CertificatePage = lazy(() => import("../pages/services/CertificatePage"));
const TransferenciasPage = lazy(() => import("../pages/services/transferencias/TransferenciasPage"));
const CredencialPage = lazy(() => import("../pages/eventos/credenciamento/CredencialPage"));
const CredencialVirtualApp = lazy(() => import("../pages/eventos/credencial-virtual/CredencialVirtualApp"));
const CredencialCheckPage = lazy(() => import("../pages/eventos/credenciamento/CredencialCheckPage"));
const LocalizacaoPage = lazy(() => import("../pages/eventos/credenciamento/LocalizacaoPage"));
const PesagemPage = lazy(() => import("../pages/eventos/pesagem/PesagemPage"));
const EventoDashboardPage = lazy(() => import("../pages/eventos/EventoDashboardPage"));
const ListaLutasQuadraPage = lazy(() => import("../pages/eventos/quadras/ListaLutasQuadraPage"));
const PainelListaDisputasPage = lazy(() => import("../pages/eventos/quadras/PainelListaDisputasPage"));
const PainelChamadaLutasPage = lazy(() => import("../pages/eventos/quadras/PainelChamadaLutasPage"));
const PremiacoesPage = lazy(() => import("../pages/eventos/premiacoes/PremiacoesPage"));
const ConsoleRebalanceamentoPage = lazy(() =>
  import("../pages/eventos/quadras/ConsoleRebalanceamentoPage"),
);
// const VirtualCredencialComponent = lazy(() => import("../pages/eventos/credenciamento/VirtualCredencialComponent"));
// const AddNoticiaPage = lazy(() => import("../pages/noticias/AddNoticiaPage"));
const DepartamentosPage = lazy(() => import("../pages/registers/departamentos/DepartamentosPage"));
const AddDepartamentoPage = lazy(() => import("../pages/registers/departamentos/AddDepartamentoPage"));
// const NoticiasPage = lazy(() => import("../pages/noticias/NoticiasPage"));
// const ViewNoticiaPage = lazy(() => import("../pages/noticias/ViewNoticiaPage"));
const NoticiasPageVersion2 = lazy(() => import("../pages/noticias/NoticiasPageVersion2"));
const ViewNoticiaPageVersion2 = lazy(() => import("../pages/noticias/ViewNoticiaPageVersion2"));
const PrintCertificadoPage = lazy(() => import("../pages/certificados/PrintCertificadoPage"));
const GaleriaPage = lazy(() => import("../pages/galeria/GaleriaPage"));
const AddGaleriaPage = lazy(() => import("../pages/galeria/AddGaleriaPage"));
const ViewGaleriaPage = lazy(() => import("../pages/galeria/ViewGaleriaPage"));
// Protótipo da Fase 4 da migração para o Flickr — rota paralela, para comparar
// as duas origens sem afetar a galeria em produção.
const ViewGaleriaFlickrPage = lazy(() => import("../pages/galeria/ViewGaleriaFlickrPage"));
const GaleriaFlickrPage = lazy(() => import("../pages/galeria/GaleriaFlickrPage"));
const GaleriaFlickrGestaoPage = lazy(() => import("../pages/galeria/GaleriaFlickrGestaoPage"));
const GaleriaFlickrCadastroPage = lazy(() => import("../pages/galeria/GaleriaFlickrCadastroPage"));

// Flickr Module
const FlickrPage = lazy(() => import("../pages/flickr/FlickrPage"));
const ViewFlickrAlbumPage = lazy(() => import("../pages/flickr/ViewFlickrAlbumPage"));
const SyncFlickrPage = lazy(() => import("../pages/flickr/SyncFlickrPage"));

const CalendarioPage = lazy(() => import("../pages/calendario/CalendarioPage"));
const AddCalendarioPage = lazy(() => import("../pages/calendario/AddCalendarioPage"));
const AddEventoPage = lazy(() => import("../pages/eventos/AddEventoPage"));
const AddPassagensFaixaPage = lazy(() => import("../pages/eventos/passagensFaixa/AddPassagemFaixaPage"));
// const EventosPage = lazy(() => import("../pages/eventos/EventosPage"));
const ViewEventoPage = lazy(() => import("../pages/eventos/ViewEventoPage"));
const PublicEventosPage = lazy(() => import("../pages/eventos/PublicEventosPage"));
const InscricaoEventoPage = lazy(() => import("../pages/eventos/InscricaoEventoPage"));
const InscricaoWizardPage = lazy(() => import("../pages/eventos/InscricaoWizardPage"));
const InscricaoEmLotePage = lazy(() => import("../pages/eventos/InscricaoEmLotePage"));
const CriarEventoFederacaoWizardPage = lazy(() => import("../pages/eventos/CriarEventoFederacaoWizardPage"));
const InscricaoKukkiwonWizardPage = lazy(() => import("../pages/eventos/InscricaoKukkiwonWizardPage"));
const InscricaoEventoPassagemFaixaPage = lazy(() => import("../pages/eventos/passagensFaixa/InscricaoEventoPassagemFaixaPage"));

// Componentes do Módulo de Faixas Pretas
const PedidosFaixasPretasPage = lazy(() => import("../pages/passagens-faixas-pretas/PedidosFaixasPretasPage"));
const FormularioAvaliacaoFaixaPreta = lazy(() => import("../components/passagens-faixas-pretas/FormularioAvaliacaoFaixaPreta"));
const PlacarFaixasPretasPage = lazy(() => import("../components/passagens-faixas-pretas/PlacarFaixasPretasPage"));
const FinalizarExameFaixaPreta = lazy(() => import("../components/passagens-faixas-pretas/FinalizarExameFaixaPreta"));
const DashboardFaixasPretasPage = lazy(() => import("../pages/passagens-faixas-pretas/DashboardFaixasPretasPage"));
const CertificadosFaixasPretasPage = lazy(() => import("../pages/passagens-faixas-pretas/CertificadosFaixasPretasPage"));
const RelatoriosFaixasPretasPage = lazy(() => import("../pages/passagens-faixas-pretas/RelatoriosFaixasPretasPage"));
const FormularioNotasTeorica = lazy(() => import("../components/passagens-faixas-pretas/FormularioNotasTeorica"));
const PlanilhaAvaliacaoEvento = lazy(() => import("../components/passagens-faixas-pretas/PlanilhaAvaliacaoEvento"));
const FichaAvaliacaoImpressao = lazy(() => import("../components/passagens-faixas-pretas/FichaAvaliacaoImpressao"));
const CredenciamentoPage = lazy(() => import("../pages/eventos/credenciamento/CredenciamentoPage"));
const SelecaoPage = lazy(() => import("../pages/selecoes/SelecaoPage"));
const AddSelecaoKyoruguiPage = lazy(() => import("../pages/selecoes/AddSelecaoKyoruguiPage"));

const HelpdeskHomePage = lazy(() => import("../pages/helpdesk/HelpdeskHomePage"));
const TicketsPage = lazy(() => import("../pages/helpdesk/TicketsPage"));
const EditTicketPage = lazy(() => import("../pages/helpdesk/EditTicketPage"));
const FaqPage = lazy(() => import("../pages/helpdesk/FaqPage"));
const EditFaqPage = lazy(() => import("../pages/helpdesk/EditFaqPage"));
const TutoriaisPage = lazy(() => import("../pages/helpdesk/TutoriaisPage"));
const EditTutoriaisPage = lazy(() => import("../pages/helpdesk/EditTutoriaisPage"));

// ── Módulo de Tarefas / CRM (M7) ──────────────────────────────────────────────
const TarefasDashboardUsuario = lazy(() => import("../pages/tarefas/TarefasDashboardUsuario"));
const TarefasDashboardGestor  = lazy(() => import("../pages/tarefas/TarefasDashboardGestor"));
const TarefaDetalhe            = lazy(() => import("../pages/tarefas/TarefaDetalhe"));
const TarefasKanban            = lazy(() => import("../pages/tarefas/TarefasKanban"));
const TarefaForm               = lazy(() => import("../pages/tarefas/TarefaForm"));
const TicketsSuporte           = lazy(() => import("../pages/tarefas/TicketsSuporte"));
const RelatorioDesempenho      = lazy(() => import("../pages/tarefas/RelatorioDesempenho"));
const ContatoTimeline          = lazy(() => import("../pages/tarefas/ContatoTimeline"));
const ContaEntidade            = lazy(() => import("../pages/tarefas/ContaEntidade"));
const SegmentosPage            = lazy(() => import("../pages/tarefas/SegmentosPage"));
const AutomacoesPage           = lazy(() => import("../pages/tarefas/AutomacoesPage"));
const ComunicacaoPage          = lazy(() => import("../pages/tarefas/ComunicacaoPage"));
const RetencaoPage             = lazy(() => import("../pages/tarefas/RetencaoPage"));
const SlaPage                  = lazy(() => import("../pages/tarefas/SlaPage"));
const SatisfacaoPage           = lazy(() => import("../pages/tarefas/SatisfacaoPage"));
const IaSugestoesPage          = lazy(() => import("../pages/tarefas/IaSugestoesPage"));
const GovernancaLgpdPage       = lazy(() => import("../pages/tarefas/GovernancaLgpdPage"));
// Página PÚBLICA de resposta a pesquisas (CSAT/NPS) — SEM ProtectedRoute (ver rota abaixo).
const PesquisaPublicaPage      = lazy(() => import("../pages/pesquisas/PesquisaPublicaPage"));

// const Style1ViewPage = lazy(() => import("../pages/conteudo/Style1ViewPage"));
const Style2ViewPage = lazy(() => import("../pages/conteudo/Style2ViewPage"));
// const Style1AddPage = lazy(() => import("../pages/conteudo/Style1AddPage"));
const Style2AddPage = lazy(() => import("../pages/conteudo/Style2AddPage"));
const BulkDownloadPage = lazy(() => import("../pages/conteudo/BulkDownloadPage"));
const FileTypeTestComponent = lazy(() => import("../components/test/FileTypeTestComponent"));
const FirebaseTestComponent = lazy(() => import("../components/test/FirebaseTestComponent"));
const MultiFirebaseTestComponent = lazy(() => import("../components/test/MultiFirebaseTestComponent"));
const StorageRecoveryComponent = lazy(() => import("../components/test/StorageRecoveryComponent"));
const FirestoreBackupComponent = lazy(() => import("../components/test/FirestoreBackupComponent"));
const TestMenuPage = lazy(() => import("../pages/test/TestMenuPage"));
const SorteioPage = lazy(() => import("../pages/sorteio/SorteioPage"));

// Componentes de administração para diagnóstico de performance
const ItemGraduacaoGubPage = lazy(() => import("../pages/admin/ItemGraduacaoGubPage"));
const DadosTaekwondoPage = lazy(() => import("../pages/admin/DadosTaekwondoPage"));
const TesteComparativoPage = lazy(() => import("../pages/admin/TesteComparativoPage"));
const TesteSistematicoPage = lazy(() => import("../pages/admin/TesteSistematicoPage"));
const MenuTestesPerformancePage = lazy(() => import("../pages/admin/MenuTestesPerformancePage"));
const CertificadosQueueMonitor = lazy(() => import("../components/certificados/CertificadosQueueMonitor"));
const CertificateConfigurationManager = lazy(() => import("../components/certificados/CertificateConfigurationManager"));
const CertificateConfigurationManagerV2 = lazy(() => import("../components/certificados/CertificateConfigurationManager_version2"));
const AdminPanel = lazy(() => import("../components/admin/AdminPanel"));
const ColetesReferenciasPage = lazy(() => import("../pages/admin/coletes/ColetesReferenciasPage"));
const AdminCertificadosPanel = lazy(() => import("../components/admin/AdminCertificadosPanel"));
const ProductionDashboard = lazy(() => import("../components/admin/ProductionDashboard"));
const ConsoleLogViewer = lazy(() => import("../components/admin/ConsoleLogViewer"));
const ManutencaoConteudosPortais = lazy(() => import("../pages/admin/ManutencaoConteudosPortais"));
const ManutencaoSimplificada = lazy(() => import("../pages/admin/ManutencaoSimplificada"));
const VersionCheckPage = lazy(() => import("../pages/admin/VersionCheckPage"));
const WebhookConfigPage = lazy(() => import("../pages/admin/WebhookConfigPage"));
const EfiSetupWizardPage = lazy(() => import("../pages/admin/EfiSetupWizardPage"));
const SicoobSetupWizardPage = lazy(() => import("../pages/admin/SicoobSetupWizardPage"));
const ServicosHabilitadosPage = lazy(() => import("../pages/admin/ServicosHabilitadosPage"));
const WizardAdesaoCertificadosPage = lazy(() => import("../pages/admin/WizardAdesaoCertificadosPage"));
const UpdatePortaisPage = lazy(() => import("../pages/admin/UpdatePortaisPage"));
const DataRecoveryPage = lazy(() => import("../pages/admin/DataRecoveryPage"));
const ImportarDadosPraticantes = lazy(() => import("../pages/admin/ImportarDadosPraticantes"));
const AssociarEntidadesImportacao = lazy(() => import("../pages/admin/AssociarEntidadesImportacao"));
const ValidarCPFImportados = lazy(() => import("../components/admin/ValidarCPFImportados"));
const AtualizarContasPix = lazy(() => import("../pages/admin/AtualizarContasPix"));
const NormalizarIsPixTaxasPage = lazy(() => import("../pages/admin/NormalizarIsPixTaxasPage"));
const MigracaoCertificadosPage = lazy(() => import("../pages/admin/MigracaoCertificadosPage"));
const MigracaoItemAvulsoPage = lazy(() => import("../pages/admin/MigracaoItemAvulsoPage"));
const MigrarAnexosConteudosPage = lazy(() => import("../pages/admin/MigrarAnexosConteudosPage"));
const TesteAnexosIndexes = lazy(() => import("../pages/admin/TesteAnexosIndexes"));
const VerificarTrigramsAnexos = lazy(() => import("../pages/admin/VerificarTrigramsAnexos"));
const AtualizarTrigramsAnexos = lazy(() => import("../pages/admin/AtualizarTrigramsAnexos"));
const TesteTrigramConteudos = lazy(() => import("../pages/admin/TesteTrigramConteudos"));
const PopularTrigramConteudos = lazy(() => import("../pages/admin/PopularTrigramConteudos"));
const DiagnosticoConteudoEstatuto = lazy(() => import("../pages/admin/DiagnosticoConteudoEstatuto"));
const DiagnosticoAnexos = lazy(() => import("../pages/admin/DiagnosticoAnexos"));
const TransferirPraticantesPage = lazy(() => import("../pages/admin/TransferirPraticantesPage"));
const TransferirInscricoesEvento = lazy(() => import("../pages/admin/TransferirInscricoesEvento"));
const RecuperarInscricoesDeInscritos = lazy(() => import("../pages/admin/sync/RecuperarInscricoesDeInscritos"));
const AddDatabaseOrigemFields = lazy(() => import("../pages/admin/sync/AddDatabaseOrigemFields"));
const CriarInscritosMembrosPage = lazy(() => import("../pages/admin/sync/CriarInscritosMembrosPage"));
const AnalisarInscricoesV2VsV3 = lazy(() => import("../pages/admin/diagnostico/AnalisarInscricoesV2VsV3"));
const TesteInscricoesUnifiedPage = lazy(() => import("../pages/admin/TesteInscricoesUnifiedPage"));
const TesteIntegracaoRelatorioPage = lazy(() => import("../pages/admin/TesteIntegracaoRelatorioPage"));
const ExtrairRegistroUnico = lazy(() => import("../pages/admin/tools/ExtrairRegistroUnico"));
const AuditoriaAcoesUsuario = lazy(() => import("../pages/admin/AuditoriaAcoesUsuario"));
const DiagnosticoFontePagadora = lazy(() => import("../components/admin/DiagnosticoFontePagadora"));
const DiagnosticoContasDuplicadas = lazy(() => import("../pages/admin/DiagnosticoContasDuplicadas"));
const FixPortiasUrls = lazy(() => import("../components/admin/FixPortiasUrls"));
const MigrarCamposCanceladoDesfiliado = lazy(() => import("../components/admin/MigrarCamposCanceladoDesfiliado"));
const MigrarCamposCanceladoDesfiliadoView = lazy(() => import("../components/admin/MigrarCamposCanceladoDesfiliadoView"));
const MigrarCampoExibirEmFiliados = lazy(() => import("../components/admin/MigrarCampoExibirEmFiliados"));
const MigrarMetadadosDesfiliado = lazy(() => import("../components/admin/MigrarMetadadosDesfiliado"));
const SyncEntityNamesInPractitioners = lazy(() => import("../components/admin/SyncEntityNamesInPractitioners"));
const ValidarNomeEntidadePorID = lazy(() => import("../components/admin/ValidarNomeEntidadePorID"));
const SyncPraticanteNamesInContas = lazy(() => import("../components/admin/SyncPraticanteNamesInContas"));
const BatchPublicarEventosPage = lazy(() => import("../pages/admin/BatchPublicarEventosPage"));
const ExcluirImportacaoEvento = lazy(() => import("../components/admin/ExcluirImportacaoEvento"));
const ConsistenciaUsuariosPortalPage = lazy(() => import("../components/admin/ConsistenciaUsuariosPortalPage"));
const InspecionarConta = lazy(() => import("../components/admin/InspecionarConta"));
const ValidarCamposBooleanPraticantes = lazy(() => import("../pages/admin/ValidarCamposBooleanPraticantes"));
const SyncActiveStatusByAnuidade2025 = lazy(() => import("../pages/admin/SyncActiveStatusByAnuidade2025"));
const RestoreMetadataInPractitioners = lazy(() => import("../components/admin/RestoreMetadataInPractitioners"));
const DuplicarColecao = lazy(() => import("../components/admin/DuplicarColecao"));
const RebuildAssociacoesView = lazy(() => import("../components/admin/RebuildAssociacoesView"));
const RebuildEntidadesView = lazy(() => import("../components/admin/RebuildEntidadesView"));
const ReplicarConteudosFederacoes = lazy(() => import("../components/admin/ReplicarConteudosFederacoes"));
const RepararUfPraticantesView = lazy(() => import("../components/admin/RepararUfPraticantesView"));
const ConfigCacheViewsView = lazy(() => import("../components/admin/ConfigCacheViewsView"));
const AuditoriaAceitesTermos = lazy(() => import("../components/admin/AuditoriaAceitesTermos"));
const ReorganizarMenusPortais = lazy(() => import("../pages/admin/ReorganizarMenusPortais"));
const AtivacaoFederativaMassaPage = lazy(() => import("../pages/admin/AtivacaoFederativaMassaPage"));
const AtivarFederativamenteGraduacoesPage = lazy(() => import("../pages/admin/AtivarFederativamenteGraduacoesPage"));
const CorrigirVinculacoesPraticantesPage = lazy(() => import("../pages/admin/CorrigirVinculacoesPraticantesPage"));
const BloquearPraticantesCadastroIncompletoPage = lazy(() => import("../pages/admin/BloquearPraticantesCadastroIncompletoPage"));
const RecalcularMaxGraduacaoPage = lazy(() => import("../pages/admin/RecalcularMaxGraduacaoPage"));
const LimpezaHistoricoServicosPage = lazy(() => import("../pages/admin/LimpezaHistoricoServicosPage"));
const DuplicarPraticanteUsuarioPage = lazy(() => import("../pages/admin/DuplicarPraticanteUsuarioPage"));
const ChatAIAdminPage = lazy(() => import("../pages/admin/ChatAIAdminPage"));
const ChatAIDocumentManager = lazy(() => import("../components/SupportChat/DocumentManager"));

// Notifications Pages
const NotificationsListPage = lazy(() => import("../pages/admin/notifications/NotificationsListPage"));
const ApprovalQueuePage = lazy(() => import("../pages/admin/notifications/ApprovalQueuePage"));
const NotificationGroupsPage = lazy(() => import("../pages/admin/notifications/NotificationGroupsPage"));
const NotificationsDashboardPage = lazy(() => import("../pages/admin/notifications/NotificationsDashboardPage"));
const RateLimitsConfigPage = lazy(() => import("../pages/admin/notifications/RateLimitsConfigPage"));
const CreateNotificationPage = lazy(() => import("../pages/admin/notifications/CreateNotificationPage"));

const ViewServicesPage = lazy(() => import("../pages/institucional/ViewTaxasPage"));
const ViewFederacoesPage = lazy(() => import("../pages/institucional/ViewFederacoesPage"));
const ViewPraticantesPage = lazy(() => import("../pages/institucional/ViewPraticantesPage"));
const ViewAssociacoesPage = lazy(() => import("../pages/institucional/ViewAssociacoesPage"));
// Versões PÚBLICAS (sem login, liberadas por captcha) das listas institucionais —
// questões 220 e 221 do questionário GET/COB. Ver components/publico/.
const FederacoesPublicasPage = lazy(() => import("../pages/publico/FederacoesPublicasPage"));
const AssociacoesPublicasPage = lazy(() => import("../pages/publico/AssociacoesPublicasPage"));
const RotaPublicaOuAutenticada = lazy(() => import("../components/publico/RotaPublicaOuAutenticada"));
const RelatorioInscricoesEventoPage = lazy(() => import("../pages/eventos/RelatorioInscricoesEventoPage"));
const AcompanhamentoInscricoesPage = lazy(() => import("../pages/eventos/AcompanhamentoInscricoesPage"));
const RelatorioRepasseInscricoesPage = lazy(() => import("../pages/eventos/RelatorioRepasseInscricoesPage"));
const InscritosEventoPage = lazy(() => import("../pages/eventos/InscritosEventoPage"));
const ImportarInscritosPage = lazy(() => import("../pages/eventos/ImportarInscritosPage"));
const FinalizarInscricoesPage = lazy(() => import("../pages/eventos/FinalizarInscricoesPage"));
// const PrintCobrancaQRCodePage = lazy(() => import("../pages/eventos/PrintCobrancaQRCodePage")); 

const CarteirinhaCertificatePage = lazy(() => import("../pages/services/carterinhas/CarteirinhaCertificatePage"));
const CarterinhasPage = lazy(() => import("../pages/services/carterinhas/CarteirinhasPage"));
const CertificadosPedidosPage = lazy(() => import("../pages/services/certificados-pedidos/CertificadosPedidosPage"));
const ValidacaoCertificadoPage = lazy(() => import("../pages/validacao/ValidacaoCertificadoPage"));
const CarteirinhaVirtualPage = lazy(() => import("../pages/carteirinhaVirtual/CarteirinhaVirtualModalComponent"));

const ViewRankingPage = lazy(() => import("../pages/ranking/ViewRankingPage"));

const ApoiadoresPage = lazy(() => import("../pages/apoiadores/ApoiadoresPage"));
const AddApoiadoresPage = lazy(() => import("../pages/apoiadores/AddApoiadoresPage"));

const SumulasPage = lazy(() => import("../pages/eventos/sumulas/SumulasPage"));
const AddSumulasPage = lazy(() => import("../pages/eventos/sumulas/AddSumulasPage"));
const TransferenciasEntreEventosPage = lazy(() => import("../pages/eventos/TransferenciasEntreEventosPage"));
const CopiaEventosEntidadesPage = lazy(() => import("../pages/eventos/CopiaEventosEntidadesPage"));
const KyoruguiRoutes = lazy(() => import("./KyoruguiRoutes"));
const ModelosModalidadesPage = lazy(() => import("../pages/modalidades/ModelosModalidadesPage"));
const AIAssistantPage = lazy(() => import("../pages/ai/AIAssistantPage"));

// Chaves de Luta - Kyorugi
const ChavesListPage = lazy(() => import("../pages/eventos/chaves/ChavesListPage"));
const ChavesWizard = lazy(() => import("../pages/eventos/chaves/ChavesWizard"));
const BracketViewer = lazy(() => import("../components/eventos/chaves/BracketViewer"));
const PodiumPage = lazy(() => import("../pages/eventos/chaves/PodiumPage"));
const SumulaChavePage = lazy(() => import("../pages/eventos/chaves/SumulaChavePage"));


// const { useEffect } = lazy(() => import("react")); 
// const { useDispatch } = lazy(() => import("react-redux")); 
// const { useLocation } = lazy(() => import("react-router-dom")); 
// const { GetSubDomain } = lazy(() => import("../utils/urlSudDomainUtil")); 

export default function AppRouter(props) {
  // const dispatch = useDispatch();
  // //console.log("Passou aqui!");
  // useEffect(() => {
  //   //console.log("Passou aqui!");
  // }, []);
  // useEffect(() => {
  //   const host = window.location.host;
  //   const arr = host.split(".").slice(0, host.includes("localhost") ? -1 : -2);
  //   if (arr.length > 0) {
  //     //console.log("arr[0]=", arr[0]);
  //     dispatch({ type: "SUBDOMAIN", payload: arr[0] });
  //   }
  // }, []);
  // //console.log("window.location.host.split('.')[0]=", window.location.host.split(".")[0]);
  // //console.log("Passou aqui!");
  // let location = useLocation();
  // //console.log("useLocation()=", useLocation());
  // let subDomainsCollection = ["fctkd", "rstkd", "prtkd"];
  // let subDomain = subDomainsCollection.find((subDomainItem) => location.pathname.includes(subDomainItem));
  // //console.log("location=", location);
  // let subDomainsCollection = ["fctkd", "rstkd", "prtkd"];
  // let subDomain = subDomainsCollection.find((subDomainItem) => location.pathname.includes(subDomainItem));
  let subDomain = ""; //GetSubDomain();
  // let location = useLocation();

  if (subDomain.length > 0) subDomain = "/" + subDomain;
  else subDomain = "";
  // //console.log("appRouter -> subDomain =", subDomain);

  // Função para determinar se deve usar CBTKDEducaHome (desenvolvimento/preview) ou EducativoHomePage (produção)
  // CBTKDEducaHome: usado em localhost e preview-sg-cbtkd.web.app para desenvolvimento
  // EducativoHomePage: usado em produção e demais ambientes
  const shouldUseCBTKDEducaHome = () => {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isPreview = hostname.includes('preview-sg-cbtkd.web.app');
    return isLocalhost || isPreview;
  };
  //if (subDomainsCollection.find(subDomainItem => (location.pathname.includes(subDomainItem)))

  //let subDomain = "";
  // useEffect(() => {
  //   if (location.pathname.includes("fctkd")) {
  //     navigate(location.pathname.replace("/fctkd", ""), { replace: true });
  //     // //console.log("location.pathname.replace('/fctkd','')=", location.pathname.replace("/fctkd", ""));
  //   }
  // });

  return (
    <>
      <ExigirTrocaDeSenha />
      <Suspense fallback={<div>Carregando (001)...</div>}>
        <Routes>
          {/* Rotas sem Layout (mobile app style) */}
          <Route
            path={`${subDomain}/eventos/evento/credencial-virtual/:eventId/:userId`}
            element={<CredencialVirtualApp />}
          />

          {/* Telões de quadra: a tela inteira é conteúdo. Ficam fora do Layout
              porque cabeçalho, menu e rodapé do portal comem ~30% da area util
              de uma TV de ginásio. A lista mora em routes/rotasTelao.js, que o
              App também consulta para não montar os widgets flutuantes. */}
          <Route
            path={`${subDomain}/eventos/evento/quadra`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <PainelListaDisputasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/chamada`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <PainelChamadaLutasPage />
              </ProtectedRoute>
            }
          />
          
          {/* Todas as outras rotas com Layout */}
          <Route
            path="*"
            element={
              <Layout subDomain={props.subDomain}>
                <Routes>
          {/* {console.log("Passou aqui!")} */}
          {/* {window.location.host.split(".")[0] === "sie" ? (
          <Route path={`${subDomain}/sie/`} element={<SieHomePage />} />
        ) : window.location.host.split(".")[0] === "dashboard" ? (
          <Route path={`${subDomain}/sie/dashboard`} element={<SieHomePage />} />
        ) : window.location.host.split(".")[0] === "institucional" ? (
          <Route path={`${subDomain}/institucional/`} element={<InstitucionalHomePage />} />
        ) : window.location.host.split(".")[0] === "transparencia" ? (
          <Route path={`${subDomain}/transparencia/`} element={<TransparenciaHomePage />} />
        ) : window.location.host.split(".")[0] === "educativo" ? (
          <Route path={`${subDomain}/educativo/`} element={<EducativoHomePage />} />
        ) : (
          <Route path={`${subDomain}/`} element={<HomePage />} />
        )} */}
          {/* {window.location.host.split(".")[0] === "fctkd" && false ? (
          <Route path={`${subDomain}/`} element={<HomeFederacaoPage />} />
        ) : ( */}
          <Route path={`${subDomain}/`} element={<HomePage />} />
          {/* )} */}
          {/* <Route path={`${subDomain}/`} element={<HomePage />} /> */}
          
          {/* 🔍 ROTA PÚBLICA - Validação de Certificados */}
          <Route path={`${subDomain}/validacao/certificado`} element={<ValidacaoCertificadoPage />} />

          {/* 📊 ROTA PÚBLICA — Resposta a pesquisa de satisfação (CSAT/NPS), CRM Sprint H
              (H4). SEM ProtectedRoute por design: acessada por link com TOKEN, por quem
              NÃO está logado (o respondente é o titular do contato). A autorização é
              inteiramente o token, validado pelo backend (/api/pesquisas-publico/:token). */}
          <Route path={`${subDomain}/pesquisa/:token`} element={<PesquisaPublicaPage />} />
          
          {/* 🧪 ROTA DE TESTE - Lazy Loading Debug */}
          <Route path={`${subDomain}/test-lazy`} element={<TestLazyPage />} />
          
          <Route path={`${subDomain}/institucional`} element={<InstitucionalHomePage />} />
          <Route path={`${subDomain}/transparencia`} element={<TransparenciaHomePage />} />

          <Route path={`${subDomain}/cbtkdeduca`} element={shouldUseCBTKDEducaHome() ? <CBTKDEducaHome /> : <EducativoHomePage />} />

          <Route path={`${subDomain}/sie`} element={<SieHomePage />} />
          <Route path={`${subDomain}/sie/dashboard`} element={<SieHomePage />} />
          <Route
            path={`${subDomain}/sie/dashboards/certificados-coloridas`}
            element={
              <ProtectedRoute requiredPermission={9900}>
                <DashboardCertificadosColoridasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/dashboards/emissao-certificados`}
            element={
              <ProtectedRoute requiredPermission={9901}>
                <DashboardEmissaoCertificadosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/admin/reconciliar-contadores-certificados`}
            element={
              <ProtectedRoute requiredPermission={9176}>
                <ReconciliarContadoresCertificadosPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/sie/editor-novidades`} element={<EditorNovidades />} />
          <Route path={`${subDomain}/Login`} element={<LoginPage />} />
          <Route path={`${subDomain}/login`} element={<Navigate to="/Login" replace />} />
          {/* <Route path={`${subDomain}/signup`} element={<SignupPage />} /> */}
          {/* <Route path={`${subDomain}/signup-validation`} element={<VerifyEmailPage />} /> */}
          <Route path={`${subDomain}/signup-validation`} element={<HomePage />} />
          {/* <Route path={`${subDomain}/excelimport`} element={<ExcelImportPage />} /> */}

          <Route
            path={`${subDomain}/profile`}
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/carteirinha-virtual`}
            element={
              <ProtectedRoute>
                <CarteirinhaVirtualPage />
              </ProtectedRoute>
            }
          />
          {/* <ProtectedRoute exact path='/profile' element={<ProfilePage/>}/> */}
          <Route path={`${subDomain}/forgot-password`} element={<ForgotPasswordPage />} />
          <Route path={`${subDomain}/reset-password`} element={<ResetPasswordConfirmPage />} />
          <Route path={`${subDomain}/change-password`} element={<ChangePasswordPage />} />
          <Route path={`${subDomain}/change-Email`} element={<ChangeEmailPage />} />
          <Route path={`${subDomain}/change-Name`} element={<ChangeNamePage />} />
          <Route path={`${subDomain}/privacy-politics`} element={<PrivacyPoliticsPage />} />
          <Route
            path={`${subDomain}/sie/administracao/usersgroups`}
            element={
              <ProtectedRoute>
                <UsersGroupsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/administracao/addusersgroup`}
            element={
              <ProtectedRoute>
                <AddUsersGroupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/administracao/users`}
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/administracao/adduser`}
            element={
              <ProtectedRoute>
                <AddUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/administracao/cpf-normalization`}
            element={
              <ProtectedRoute>
                <CPFNormalizationTool />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/cadastros/pessoas`}
            element={
              <ProtectedRoute>
                <PraticantesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/admin/cache-cpf-manual`}
            element={
              <ProtectedRoute>
                <CacheCpfManualPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/cadastros/addpraticante`}
            element={
              <ProtectedRoute>
                <AddPraticantesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/addconta`}
            element={
              <ProtectedRoute>
                <AddContaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/receitas`}
            element={
              <ProtectedRoute>
                <ContasReceberPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/receitas/relatorio-uf`}
            element={
              <ProtectedRoute>
                <RelatorioReceitasUFPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/despesas`}
            element={
              <ProtectedRoute>
                <ContasPagarPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/cadastros/entidades`}
            element={
              <ProtectedRoute>
                <EntidadesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/cadastros/entidades/addentidade`}
            element={
              <ProtectedRoute>
                <AddEntidadePage />
              </ProtectedRoute>
            }
          />

          {/* <Route
          path={`${subDomain}/sie/eventos`}
          element={
            <ProtectedRoute>
              <EventosPage />
            </ProtectedRoute>
          }
        /> */}
          {/* Ferramenta administrativa "Categorias e Pesos Kyorugui".
              Estava atras de um gate `import.meta.env.MODE === 'development'`,
              entao no build de producao a rota nao era registrada e
              /sie/kyorugui caia no catch-all (NotFoundPage / 404).
              A 2201 ("Kyorugui gerenciamento : Recuperar") e a permissao de
              leitura da ferramenta — e a mesma que o KyoruguiManager exige
              internamente e que esconde o card no AdminPanel. */}
          <Route
            path={`${subDomain}/sie/kyorugui/*`}
            element={
              <ProtectedRoute requiredPermission={2201}>
                <KyoruguiRoutes />
              </ProtectedRoute>
            }
          />
          {/* Modelos de modalidades (regras padrão copiadas para cada evento novo).
              2210 "Modalidades gerenciamento : Visualizar" ou 2212 "... : Atualizar";
              a gravação confere a 2212 dentro da tela. */}
          <Route
            path={`${subDomain}/sie/modalidades`}
            element={
              <ProtectedRoute requiredPermission={MODALIDADES_ACESSO}>
                <ModelosModalidadesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/addpassagensfaixa`}
            element={
              <ProtectedRoute>
                <AddPassagensFaixaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/addevento`}
            element={
              <ProtectedRoute>
                <AddEventoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/inscricao`}
            element={
              <ProtectedRoute>
                <InscricaoEventoPage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={`${subDomain}/eventos/wizard-inscricao`}
            element={
              <ProtectedRoute>
                <InscricaoWizardPage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={`${subDomain}/eventos/inscricao-em-lote`}
            element={
              // Só as permissões de lote (semântica "qualquer uma delas"). A 1610
              // ("Inscrição > Criar") governa a inscrição INDIVIDUAL e era o que
              // barrava mestres e responsáveis por entidade aqui — ver
              // eventos/helpers/permissoesLoteEvento.js.
              <ProtectedRoute requiredPermission={[1655, 1656, 1657]}>
                <InscricaoEmLotePage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={`${subDomain}/eventos/wizard-federacao`}
            element={
              <ProtectedRoute>
                <CriarEventoFederacaoWizardPage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={`${subDomain}/eventos/wizard-kukkiwon`}
            element={
              <ProtectedRoute>
                <InscricaoKukkiwonWizardPage />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path={`${subDomain}/eventos/inscricaoexamefaixa`}
            element={
              <ProtectedRoute>
                <InscricaoEventoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/inscricaoexamekukkiwon`}
            element={
              <ProtectedRoute>
                <InscricaoEventoPassagemFaixaPage />
              </ProtectedRoute>
            }
          />
          {/* <Route path={`${subDomain}/eventos/printcobrancaqrcode`} element={<PrintCobrancaQRCodePage />} /> */}
          <Route path={`${subDomain}/eventos/evento`} element={<ViewEventoPage />} />
          <Route path={`${subDomain}/eventos`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/competicoes`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/examesdefaixa`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/cursos`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/seminarios`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/eventos/examesdefaixa`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/eventos/cursos`} element={<PublicEventosPage />} />
          <Route path={`${subDomain}/eventos/seminarios`} element={<PublicEventosPage />} />
          {/* <Route path={`${subDomain}/eventos/inscritos`} element={<RelatorioInscricoesEventoPage />} /> */}
          <Route path={`${subDomain}/eventos/inscritos/listaprevia`} element={<ProtectedRoute><RelatorioInscricoesEventoPage /></ProtectedRoute>} />
          <Route path={`${subDomain}/eventos/inscritos/listafinal`} element={<ProtectedRoute><RelatorioInscricoesEventoPage /></ProtectedRoute>} />
          <Route
            path={`${subDomain}/eventos/acompanhamento-inscricoes`}
            element={
              <ProtectedRoute requiredPermission={1650}>
                <AcompanhamentoInscricoesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/relatorio-repasse`}
            element={
              <ProtectedRoute requiredPermission={1668}>
                <RelatorioRepasseInscricoesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/inscritos-evento`}
            element={
              <ProtectedRoute requiredPermission={1652}>
                <InscritosEventoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/importar-inscritos`}
            element={
              <ProtectedRoute requiredPermission={1665}>
                <ImportarInscritosPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/eventos/sumulas`} element={<SumulasPage />} />
          {/* <Route path={`${subDomain}/eventos/credenciais`} element={<CredenciaisPage />} /> */}
          {/* Rotas de Chaves de Luta */}
          <Route
            path={`${subDomain}/eventos/chaves`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <ChavesListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/chaves/criar`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_OPERAR}>
                <ChavesWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/chaves/visualizar/:id`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <BracketViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/chaves/podio/:id`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <PodiumPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/chaves/sumula/:id`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_OPERAR}>
                <SumulaChavePage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/sumulas`}
            element={
              <ProtectedRoute>
                <SumulasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/sumulas/addsumula`}
            element={
              <ProtectedRoute>
                <AddSumulasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/credenciamento`}
            element={
              <ProtectedRoute>
                <CredenciamentoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/credencial`}
            element={
              // <ProtectedRoute>
                <CredencialPage />
              // </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/credencialcheck`}
            element={
              <ProtectedRoute>
                <CredencialCheckPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/localizacao`}
            element={
              <ProtectedRoute>
                <LocalizacaoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/pesagem`}
            element={
              <ProtectedRoute requiredPermission={1830}>
                <PesagemPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/dashboard`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <EventoDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/lista-quadras`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <ListaLutasQuadraPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/premiacoes`}
            element={
              <ProtectedRoute requiredPermission={CHAVES_ACESSO}>
                <PremiacoesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/eventos/evento/rebalanceamento`}
            element={
              <ProtectedRoute requiredPermission={REBALANCEAMENTO_ACESSO}>
                <ConsoleRebalanceamentoPage />
              </ProtectedRoute>
            }
          />
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/eventos/evento/inscricoes/finalizador`}
            element={
              <ProtectedRoute>
                <FinalizarInscricoesPage />
              </ProtectedRoute>
            }
          />
          )}
          
          {/* Rota disponível apenas em desenvolvimento */}
          {import.meta.env.MODE === 'development' && (
            <Route
              path={`${subDomain}/sie/eventos/transferencias`}
              element={
                <ProtectedRoute>
                  <TransferenciasEntreEventosPage />
                </ProtectedRoute>
              }
            />
          )}

          {/* Rota disponível apenas em desenvolvimento */}
          {import.meta.env.MODE === 'development' && (
            <Route
              path={`${subDomain}/sie/eventos/copia-eventos-entidades`}
              element={
                <ProtectedRoute>
                  <CopiaEventosEntidadesPage />
                </ProtectedRoute>
              }
            />
          )}

          {/* ======================================== */}
          {/*   ROTAS DO MÓDULO DE FAIXAS PRETAS      */}
          {/* ======================================== */}
          
          {/* Pedidos - Visualização e Gerenciamento (Federações e CBTKD) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/pedidos`}
            element={
              <ProtectedRoute requiredPermission={5000}>
                <PedidosFaixasPretasPage />
              </ProtectedRoute>
            }
          />

          {/* Avaliação - Formulário de Avaliação (Avaliadores) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/avaliar`}
            element={
              <ProtectedRoute requiredPermission={5030}>
                <FormularioAvaliacaoFaixaPreta />
              </ProtectedRoute>
            }
          />

          {/* Placar - Visualização ao Vivo (Público ou com permissão) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/placar`}
            element={
              <ProtectedRoute requiredPermission={5031}>
                <PlacarFaixasPretasPage />
              </ProtectedRoute>
            }
          />

          {/* Finalização - Tornar Resultados Imutáveis (CBTKD) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/finalizar`}
            element={
              <ProtectedRoute requiredPermission={5040}>
                <FinalizarExameFaixaPreta />
              </ProtectedRoute>
            }
          />

          {/* Dashboard - Estatísticas (CBTKD e Federações) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/dashboard`}
            element={
              <ProtectedRoute requiredPermission={5001}>
                <DashboardFaixasPretasPage />
              </ProtectedRoute>
            }
          />

          {/* Certificados - Emissão de Certificados (CBTKD) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/certificados`}
            element={
              <ProtectedRoute requiredPermission={5041}>
                <CertificadosFaixasPretasPage />
              </ProtectedRoute>
            }
          />

          {/* Relatórios - Exportação de dados (CBTKD e Federações) */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/relatorios`}
            element={
              <ProtectedRoute requiredPermission={5000}>
                <RelatoriosFaixasPretasPage />
              </ProtectedRoute>
            }
          />

          {/* Notas Teóricas - Lançamento pelo responsável da prova */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/notas-teorica`}
            element={
              <ProtectedRoute requiredPermission={[5033, 5040]}>
                <FormularioNotasTeorica />
              </ProtectedRoute>
            }
          />

          {/* Planilha - Lançamento offline pelo organizador */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/planilha`}
            element={
              <ProtectedRoute requiredPermission={[5033, 5040]}>
                <PlanilhaAvaliacaoEvento />
              </ProtectedRoute>
            }
          />

          {/* Fichas de Impressão - PDF para uso no evento */}
          <Route
            exact
            path={`${subDomain}/faixas-pretas/imprimir`}
            element={
              <ProtectedRoute requiredPermission={5000}>
                <FichaAvaliacaoImpressao />
              </ProtectedRoute>
            }
          />

          {/* ======================================== */}
          {/*   FIM DAS ROTAS DE FAIXAS PRETAS        */}
          {/* ======================================== */}

          <Route
            path={`${subDomain}/sie/financeiro/services`}
            element={
              <ProtectedRoute>
                <ServicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/addservice`}
            element={
              <ProtectedRoute>
                <AddServicePage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/services/wizard`}
            element={
              <ProtectedRoute requiredPermission={705}>
                <WizardTaxaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/financeiro/importar-taxas`}
            element={
              <ProtectedRoute>
                <ImportTaxasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/servicos/certificados`}
            element={
              <ProtectedRoute>
                <CertificationsPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/validacao/certificado`} element={<CertificatePage />} />
          <Route
            path={`${subDomain}/sie/servicos/carterinhas`}
            element={
              <ProtectedRoute>
                <CarterinhasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/servicos/certificados-pedidos`}
            element={
              <ProtectedRoute>
                <CertificadosPedidosPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/validacao/carteira`} element={<CarteirinhaCertificatePage />} />
          <Route
            path={`${subDomain}/sie/servicos/transferencias`}
            element={
              <ProtectedRoute>
                <TransferenciasPage />
              </ProtectedRoute>
            }
          />


          <Route
            path={`${subDomain}/sie/administracao/adddepartamento`}
            element={
              <ProtectedRoute>
                <AddDepartamentoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/sie/administracao/departamentos`}
            element={
              <ProtectedRoute>
                <DepartamentosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/noticias/addnoticia`}
            element={
              <ProtectedRoute>
                <Style2AddPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/noticias/noticia`} element={
            <ViewNoticiaPageVersion2 />
          } />
          <Route path={`${subDomain}/noticias`} element=
            {
              <NoticiasPageVersion2 />
            }
          />
          <Route path={`${subDomain}/noticias/filiados`} element={<ProtectedRoute><ViewPraticantesPage /></ProtectedRoute>} />

          <Route
            path={`${subDomain}/apoiadores`}
            element={
              <ProtectedRoute>
                <ApoiadoresPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/apoiadores/addapoiador`}
            element={
              <ProtectedRoute>
                <AddApoiadoresPage />
              </ProtectedRoute>
            }
          />

          <Route path={`${subDomain}/selecoes`} element={<SelecaoPage />} />
          <Route
            path={`${subDomain}/selecoes/kyorugui/addselecao`}
            element={
              <ProtectedRoute>
                <AddSelecaoKyoruguiPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/galeria/addimagem`}
            element={
              <ProtectedRoute>
                <AddGaleriaPage />
              </ProtectedRoute>
            }
          />

          {/* Fase 4 promovida: as telas servidas pelo Flickr assumem as rotas
              oficiais da galeria. As antigas continuam alcançáveis enquanto a
              fase estiver em observação — /galeria/album-storage serve as
              imagens do Firebase Storage e /galeria/legado é a listagem
              administrativa anterior. */}
          <Route path={`${subDomain}/galeria/album`} element={<ViewGaleriaFlickrPage />} />
          <Route path={`${subDomain}/galeria/album-storage`} element={<ViewGaleriaPage />} />
          {/* Gestão: exige login e ao menos uma das regras de gestão da galeria
              (1202 editar, 1203 excluir, 1204 estado). Cada ação confere a sua
              própria regra dentro da página. */}
          <Route
            path={`${subDomain}/galeria/gestao`}
            element={
              <ProtectedRoute requiredPermission={[1202, 1203, 1204]}>
                <GaleriaFlickrGestaoPage />
              </ProtectedRoute>
            }
          />
          {/* Cadastro novo: criar exige 1200, editar exige 1202. A tela antiga
              segue em /galeria/addimagem enquanto a Fase 4 está em observação. */}
          <Route
            path={`${subDomain}/galeria/criar`}
            element={
              <ProtectedRoute requiredPermission={1200}>
                <GaleriaFlickrCadastroPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/galeria/editar`}
            element={
              <ProtectedRoute requiredPermission={1202}>
                <GaleriaFlickrCadastroPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/galeria/legado`} element={<GaleriaPage />} />
          <Route path={`${subDomain}/galeria`} element={<GaleriaFlickrPage />} />

          {/* Apelidos do período de protótipo: os endereços /galeria-flickr* e
              /galeria/album-flickr seguem servindo as mesmas telas, para não
              quebrar links já compartilhados. Remover depois da observação. */}
          <Route path={`${subDomain}/galeria/album-flickr`} element={<ViewGaleriaFlickrPage />} />
          <Route path={`${subDomain}/galeria-flickr`} element={<GaleriaFlickrPage />} />
          <Route
            path={`${subDomain}/galeria-flickr/gestao`}
            element={
              <ProtectedRoute requiredPermission={[1202, 1203, 1204]}>
                <GaleriaFlickrGestaoPage />
              </ProtectedRoute>
            }
          />

          {/* Flickr Module Routes */}
          <Route path={`${subDomain}/flickr`} element={<FlickrPage />} />
          <Route path={`${subDomain}/flickr/album`} element={<ViewFlickrAlbumPage />} />
          <Route 
            path={`${subDomain}/flickr/sync`} 
            element={
              <ProtectedRoute>
                <SyncFlickrPage />
              </ProtectedRoute>
            } 
          />

          <Route
            path={`${subDomain}/calendario/addagendamento`}
            element={
              <ProtectedRoute>
                <AddCalendarioPage />
              </ProtectedRoute>
            }
          />
          <Route path={`${subDomain}/calendario`} element={<CalendarioPage />} />

          <Route
            path={`${subDomain}/helpdesk`}
            element={
              <ProtectedRoute>
                <HelpdeskHomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/faqs`}
            element={
              <ProtectedRoute>
                <FaqPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/editfaq`}
            element={
              <ProtectedRoute>
                <EditFaqPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/tutoriais`}
            element={
              <ProtectedRoute>
                <TutoriaisPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/edittutorial`}
            element={
              <ProtectedRoute>
                <EditTutoriaisPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/tickets`}
            element={
              <ProtectedRoute>
                <TicketsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/helpdesk/editticket`}
            element={
              <ProtectedRoute>
                <EditTicketPage />
              </ProtectedRoute>
            }
          />

          {/* ── Módulo de Tarefas ───────────────────────────────────────── */}
          {/* Rotas do CRM atrás do liga/desliga POR PORTAL (servicos.crm, opt-in):
              desligado → /modulo-indisponivel. Rota de layout (sem path) para a guarda
              ficar montada entre as telas do CRM. O CRM é módulo DENTRO do SIE; não há
              mais rota federada (Module Federation removida em 23/10/2026). */}
          <Route element={<GuardaModuloCrm />}>
          <Route
            path={`${subDomain}/tarefas/nova`}
            element={
              <ProtectedRoute requiredPermission={3401}>
                <TarefaForm />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/kanban`}
            element={
              <ProtectedRoute requiredPermission={3400}>
                <TarefasKanban />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/gestor`}
            element={
              <ProtectedRoute requiredPermission={3406}>
                <TarefasDashboardGestor />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/tickets`}
            element={
              <ProtectedRoute requiredPermission={[3407, 3406, 3409]}>
                <TicketsSuporte />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/relatorio`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3408, 3409]}>
                <RelatorioDesempenho />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/contato/:userId`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <ContatoTimeline />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/conta/:entidadeId`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <ContaEntidade />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/segmentos`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <SegmentosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/automacoes`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <AutomacoesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/comunicacao`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <ComunicacaoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/retencao`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <RetencaoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/sla`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <SlaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/satisfacao`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <SatisfacaoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/ia-sugestoes`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409, 3407]}>
                <IaSugestoesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/lgpd`}
            element={
              <ProtectedRoute requiredPermission={[3406, 3409]}>
                <GovernancaLgpdPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/:tarefaId/editar`}
            element={
              /* Editar exige 3402 (a própria, sendo responsável) ou 3403 (qualquer).
                 Estava gateada em 3400 — "ver as próprias" —, mais frouxa que a
                 ação: quem digitasse a URL entrava na rota e só então o formulário
                 negava. O redirecionamento tem de vir da rota; negar lá dentro faz
                 a pessoa percorrer o caminho para ouvir não. A nuance de 3402 só
                 valer quando responsável segue onde ela pode ser avaliada, em
                 TarefaDetalhe/TarefaForm — a rota não conhece a tarefa ainda. */
              <ProtectedRoute requiredPermission={[3402, 3403]}>
                <TarefaForm />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas/:tarefaId`}
            element={
              <ProtectedRoute requiredPermission={3400}>
                <TarefaDetalhe />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/tarefas`}
            element={
              <ProtectedRoute requiredPermission={3400}>
                <TarefasDashboardUsuario />
              </ProtectedRoute>
            }
          />
          </Route>

          <Route
            path={`${subDomain}/content/addcontent`}
            element={
              <ProtectedRoute>
                <Style2AddPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/content/bulk-download`}
            element={
              <ProtectedRoute>
                <BulkDownloadPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/file-detection`}
            element={
              <ProtectedRoute>
                <FileTypeTestComponent />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/menu`}
            element={
              <ProtectedRoute>
                <TestMenuPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/firebase`}
            element={
              <ProtectedRoute>
                <FirebaseTestComponent />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/multi-firebase`}
            element={
              <ProtectedRoute>
                <MultiFirebaseTestComponent />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/storage-recovery`}
            element={
              <ProtectedRoute>
                <StorageRecoveryComponent />
              </ProtectedRoute>
            }
          />

          <Route
            path={`${subDomain}/sie/test/firestore-backup`}
            element={
              <ProtectedRoute>
                <FirestoreBackupComponent />
              </ProtectedRoute>
            }
          />

          {/* 🔒 Ranking exige login: renderiza fotos de atletas lendo praticantes.view,
              que passa a exigir auth na Fase 3 (ver HANDOFF_LOGIN_LISTAS_INSTITUCIONAIS.md). */}
          <Route path={`${subDomain}/preview/ranking`} element={
            <ProtectedRoute>
              <ViewRankingPage />
            </ProtectedRoute>
          } />

          <Route path={`${subDomain}/preview/sorteio`} element={
            <SorteioPage />
          } />

          <Route path={`${subDomain}/content`} element={
            <Style2ViewPage />
          } />
          <Route path={`${subDomain}/sie/content`} element={
            <Style2ViewPage />
          } />
          <Route path={`${subDomain}/transparencia/content`} element={<Style2ViewPage />} />

          <Route path={`${subDomain}/institucional/content`} element={<Style2ViewPage />} />
          <Route path={`${subDomain}/institucional/regimentotaxas`} element={<ProtectedRoute><ViewServicesPage /></ProtectedRoute>} />
          <Route
            path={`${subDomain}/institucional/regimentotaxas/addservice`}
            element={
              <ProtectedRoute>
                <AddServicePage />
              </ProtectedRoute>
            }
          />

          {/* 🌐 PÚBLICA COM CAPTCHA (questão 220 do GET/COB): anônimo vê a lista mínima
              (nome, cidade-sede, UF); logado vê a página completa com edição. */}
          <Route
            path={`${subDomain}/institucional/federacoes`}
            element={
              <RotaPublicaOuAutenticada publica={<FederacoesPublicasPage />}>
                <ViewFederacoesPage />
              </RotaPublicaOuAutenticada>
            }
          />
          <Route
            path={`${subDomain}/institucional/federacoes/addfederacao`}
            element={
              <ProtectedRoute>
                <AddEntidadePage />
              </ProtectedRoute>
            }
          />

          <Route path={`${subDomain}/institucional/filiados`} element={<ProtectedRoute><ViewPraticantesPage /></ProtectedRoute>} />
          <Route
            path={`${subDomain}/institucional/filiados/addfiliado`}
            element={
              <ProtectedRoute>
                <AddPraticantesPage />
              </ProtectedRoute>
            }
          />
          {/* 🌐 PÚBLICA COM CAPTCHA (questão 221 do GET/COB): anônimo vê a lista mínima
              (nome, cidade-sede, UF, filiação); logado vê a página completa. */}
          <Route
            path={`${subDomain}/institucional/associacoes`}
            element={
              <RotaPublicaOuAutenticada publica={<AssociacoesPublicasPage />}>
                <ViewAssociacoesPage />
              </RotaPublicaOuAutenticada>
            }
          />
          <Route
            path={`${subDomain}/institucional/associacoes/addassociacao`}
            element={
              <ProtectedRoute>
                <AddEntidadePage />
              </ProtectedRoute>
            }
          />

          <Route path={`${subDomain}/cbtkdeduca/content`} element={<Style2ViewPage />} />
          
          {/* Rotas do CBTKDeduca */}
          <Route path={`${subDomain}/cbtkdeduca/videos`} element={shouldUseCBTKDEducaHome() ? <CBTKDEducaHome /> : <EducativoHomePage />} />
          <Route path={`${subDomain}/cbtkdeduca/video/:id`} element={<VideoDetalhes />} />
          <Route path={`${subDomain}/cbtkdeduca/postagens`} element={shouldUseCBTKDEducaHome() ? <CBTKDEducaHome /> : <EducativoHomePage />} />
          <Route path={`${subDomain}/cbtkdeduca/postagem/:id`} element={<PostagemDetalhes />} />
          <Route path={`${subDomain}/cbtkdeduca/noticias`} element={shouldUseCBTKDEducaHome() ? <CBTKDEducaHome /> : <EducativoHomePage />} />
          <Route path={`${subDomain}/cbtkdeduca/comunicados`} element={shouldUseCBTKDEducaHome() ? <CBTKDEducaHome /> : <EducativoHomePage />} />
          
          {/* Rotas do CBTKDeduca Classroom */}
          <Route path={`${subDomain}/cbtkdeduca/turmas`} element={<TurmasManager />} />
          <Route path={`${subDomain}/cbtkdeduca/turma/:turmaId`} element={<TurmaDetalhes />} />
          <Route path={`${subDomain}/cbtkdeduca/turma/:turmaId/configuracoes`} element={<TurmaConfiguracoes />} />
          <Route path={`${subDomain}/cbtkdeduca/turma/:turmaId/tarefa/:tarefaId`} element={<TarefaDetalhes />} />
          <Route path={`${subDomain}/cbtkdeduca/turma/:turmaId/material/:materialId`} element={<MaterialDetalhes />} />
          <Route path={`${subDomain}/cbtkdeduca/professores`} element={<ProfessoresManager />} />
          <Route path={`${subDomain}/cbtkdeduca/professor/:professorId`} element={<ProfessorPerfil />} />
          
          {/* Rotas administrativas do CBTKDeduca - apenas para usuários autorizados */}
          <Route
            path={`${subDomain}/cbtkdeduca/admin/*`}
            element={
              <ProtectedRoute>
                <CBTKDEducaAdmin />
              </ProtectedRoute>
            }
          />

          <Route path={`${subDomain}/sie/printimage`} element={<PrintImagePage />} />
          <Route path={`${subDomain}/sie/financeiro/printrecibo`} element={<PrintReciboPage />} />
          <Route path={`${subDomain}/sie/financeiro/printfatura`} element={<PrintFaturaPage />} />
          <Route path={`${subDomain}/sie/certificados/printcertificado`} element={<PrintCertificadoPage />} />

          {/* Rotas para diagnóstico de performance */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/itemgraduacaogub`}
            element={
              <ProtectedRoute>
                <ItemGraduacaoGubPage />
              </ProtectedRoute>
            }
          />
          )}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/dadostaekwondo`}
            element={
              <ProtectedRoute>
                <DadosTaekwondoPage />
              </ProtectedRoute>
            }
          />
          )}
          
          {/* Nova rota para teste comparativo dos componentes */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/teste-comparativo`}
            element={
              <ProtectedRoute>
                <TesteComparativoPage />
              </ProtectedRoute>
            }
          />
          )}
          
          {/* Nova rota para teste sistemático com ItemGraduacaoGubComponent */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/teste-sistematico`}
            element={
              <ProtectedRoute>
                <TesteSistematicoPage />
              </ProtectedRoute>
            }
          />
          )}
          
          {/* Menu para navegação entre todos os testes */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/testes-performance`}
            element={
              <ProtectedRoute>
                <MenuTestesPerformancePage />
              </ProtectedRoute>
            }
          />
          )}

          {/* Rota para Verificação de Versões do Sistema */}
          <Route
            path={`${subDomain}/admin/version-check`}
            element={
              <ProtectedRoute>
                <VersionCheckPage />
              </ProtectedRoute>
            }
          />

          {/* Painel Administrativo Principal - REMOVIDO (usando AdminPanel mais abaixo) */}
          {/* <Route
            path={`${subDomain}/admin`}
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          /> */}

          {/* Rota para Configuração de Webhook PIX */}
          <Route
            path={`${subDomain}/admin/webhook-config`}
            element={
              <ProtectedRoute>
                <WebhookConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Wizard de Configuração EFI */}
          <Route
            path={`${subDomain}/admin/efi-setup-wizard`}
            element={
              <ProtectedRoute requiredPermission={9305}>
                <EfiSetupWizardPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Wizard de Configuração Sicoob */}
          <Route
            path={`${subDomain}/admin/sicoob-setup-wizard`}
            element={
              <ProtectedRoute requiredPermission={9307}>
                <SicoobSetupWizardPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Serviços Habilitados por Entidade */}
          <Route
            path={`${subDomain}/admin/servicos-habilitados`}
            element={
              <ProtectedRoute requiredPermission={9306}>
                <ServicosHabilitadosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Wizard de Adesão a Certificados por Federações */}
          <Route
            path={`${subDomain}/admin/wizard-adesao-certificados`}
            element={
              <ProtectedRoute requiredPermission={9306}>
                <WizardAdesaoCertificadosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Deploy de Regras de Segurança */}
          <Route
            path={`${subDomain}/admin/deploy-security-rules`}
            element={
              <ProtectedRoute>
                <DeploySecurityRules />
              </ProtectedRoute>
            }
          />

          {/* Rota para Logs do Sistema */}
          <Route
            path={`${subDomain}/admin/logs`}
            element={
              <ProtectedRoute>
                <SystemLogsPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Regras de Segurança */}
          <Route
            path={`${subDomain}/admin/security-rules`}
            element={
              <ProtectedRoute>
                <SecurityRulesPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Grupos de Usuários */}
          <Route
            path={`${subDomain}/admin/security-groups`}
            element={
              <ProtectedRoute>
                <SecurityGroupsPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Configurações do Sistema */}
          <Route
            path={`${subDomain}/admin/system-config`}
            element={
              <ProtectedRoute>
                <SystemConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Manutenção */}
          <Route
            path={`${subDomain}/admin/maintenance`}
            element={
              <ProtectedRoute>
                <MaintenancePage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Inventário de Fim de Ano */}
          <Route
            path={`${subDomain}/admin/year-end-inventory`}
            element={
              <ProtectedRoute>
                <YearEndInventoryPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Acompanhamento de Tarefas do Projeto — regra 3184 */}
          <Route
            path={`${subDomain}/sie/acompanhamento-tarefas`}
            element={
              <ProtectedRoute requiredPermission={3184}>
                <AcompanhamentoTarefasPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Estrutura Técnica de Desenvolvimento — regra 3186
              (própria, mais restrita que a 3184: expõe valores de hardware,
              assinaturas e IDs de transação de fatura) */}
          <Route
            path={`${subDomain}/sie/estrutura-tecnica`}
            element={
              <ProtectedRoute requiredPermission={3186}>
                <EstruturaTecnicaPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Geração em Lote de Taxas com Abono */}
          <Route
            exact
            path={`${subDomain}/admin/batch-tax-generation`}
            element={
              <ProtectedRoute requiredPermission={3107}>
                <BatchTaxGenerationPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Lançamento Taxa 1º DAN 2026 - Presente Dez/2025 */}
          <Route
            exact
            path={`${subDomain}/admin/lancamento-taxa-registro-1dan-2026`}
            element={
              <ProtectedRoute requiredPermission={3108}>
                <LancamentoTaxa1Dan2026Page />
              </ProtectedRoute>
            }
          />

          {/* Rota para Corrigir Contas Sem Número */}
          <Route
            exact
            path={`${subDomain}/admin/corrigir-contas-sem-numero`}
            element={
              <ProtectedRoute requiredPermission={9045}>
                <CorrigirContasSemNumeroPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Criar Documentos Inscritos V4 */}
          <Route
            exact
            path={`${subDomain}/admin/criar-inscritos-v4`}
            element={
              <ProtectedRoute>
                <CriarInscritosV4Page />
              </ProtectedRoute>
            }
          />

          {/* Rota para Comparação de Listas de Praticantes */}
          <Route
            exact
            path={`${subDomain}/admin/comparacao-listas-praticantes`}
            element={
              <ProtectedRoute>
                <ComparacaoListasPraticantes />
              </ProtectedRoute>
            }
          />

          {/* Rota para Relatórios Financeiros */}
          <Route
            path={`${subDomain}/admin/financial-reports`}
            element={
              <ProtectedRoute requiredPermission={9040}>
                <FinancialReportsPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Configuração Financeira */}
          <Route
            path={`${subDomain}/admin/financial-config`}
            element={
              <ProtectedRoute requiredPermission={9041}>
                <FinancialConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Atualizar Portais */}
          <Route
            path={`${subDomain}/admin/update-portais`}
            element={
              <ProtectedRoute>
                <UpdatePortaisPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Recuperação de Dados */}
          <Route
            path={`${subDomain}/admin/data-recovery`}
            element={
              <ProtectedRoute>
                <DataRecoveryPage />
              </ProtectedRoute>
            }
          />

          {/* Assistente de importação de praticantes por planilha (regra 373) */}
          <Route
            path={`${subDomain}/admin/importar-dados-praticantes`}
            element={
              <ProtectedRoute requiredPermission={373}>
                <ImportarDadosPraticantes />
              </ProtectedRoute>
            }
          />

          {/* Associação de entidades delegada numa importação de praticantes. SEM
              requiredPermission, por desenho: o convidado não tem a 373 — o backend
              autoriza pela sessão (uid na lista, sessão aberta, convite válido). */}
          <Route
            path={`${subDomain}/importacao/entidades/:sessaoId`}
            element={
              <ProtectedRoute>
                <AssociarEntidadesImportacao />
              </ProtectedRoute>
            }
          />

          {/* Validação em lote do CPF dos praticantes importados (regra 374) */}
          <Route
            path={`${subDomain}/admin/validar-cpf-importados`}
            element={
              <ProtectedRoute requiredPermission={374}>
                <ValidarCPFImportados />
              </ProtectedRoute>
            }
          />

          {/* Rota para Atualização de Contas PIX */}
          <Route
            path={`${subDomain}/admin/atualizar-contas-pix`}
            element={
              <ProtectedRoute requiredPermission={9150}>
                <AtualizarContasPix />
              </ProtectedRoute>
            }
          />

          {/* Rota para Normalização de isPix das Taxas */}
          <Route
            path={`${subDomain}/admin/normalizar-ispix-taxas`}
            element={
              <ProtectedRoute requiredPermission={9150}>
                <NormalizarIsPixTaxasPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Limpeza de Anexos Duplicados */}
          <Route
            path={`${subDomain}/admin/limpar-anexos-duplicados`}
            element={
              <ProtectedRoute requiredPermission={9190}>
                <LimparAnexosDuplicados />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de Certificados */}
          <Route
            path={`${subDomain}/admin/migracao-certificados`}
            element={
              <ProtectedRoute>
                <MigracaoCertificadosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Exportação de Divergências de Nomes */}
          <Route
            path={`${subDomain}/admin/exportacao-divergencias`}
            element={
              <ProtectedRoute>
                <ExportacaoDivergenciasPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Exportação de Praticantes Desatualizados */}
          <Route
            path={`${subDomain}/admin/exportacao-desatualizados`}
            element={
              <ProtectedRoute>
                <ExportacaoDesatualizadosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Exportação de Entidades com Quantidade de Filiados */}
          <Route
            path={`${subDomain}/admin/exportacao-entidades-filiados`}
            element={
              <ProtectedRoute requiredPermission={9112}>
                <ExportacaoEntidadesFiliadosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de Item Avulso */}
          <Route
            path={`${subDomain}/admin/migracao-item-avulso`}
            element={
              <ProtectedRoute>
                <MigracaoItemAvulsoPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de Anexos de Conteúdos */}
          <Route
            path={`${subDomain}/admin/migrar-anexos-conteudos`}
            element={
              <ProtectedRoute>
                <MigrarAnexosConteudosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Teste de Índices de Anexos */}
          <Route
            path={`${subDomain}/admin/teste-anexos-indexes`}
            element={
              <ProtectedRoute>
                <TesteAnexosIndexes />
              </ProtectedRoute>
            }
          />

          {/* Rota para Verificar Trigrams dos Anexos */}
          <Route
            path={`${subDomain}/admin/verificar-trigrams-anexos`}
            element={
              <ProtectedRoute>
                <VerificarTrigramsAnexos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Atualizar Trigrams dos Anexos */}
          <Route
            path={`${subDomain}/admin/atualizar-trigrams-anexos`}
            element={
              <ProtectedRoute>
                <AtualizarTrigramsAnexos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Testar Trigrams dos Conteúdos */}
          <Route
            path={`${subDomain}/admin/teste-trigram-conteudos`}
            element={
              <ProtectedRoute>
                <TesteTrigramConteudos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Popular Trigrams na Coleção Conteúdos */}
          <Route
            path={`${subDomain}/admin/popular-trigram-conteudos`}
            element={
              <ProtectedRoute>
                <PopularTrigramConteudos />
              </ProtectedRoute>
            }
          />

          {/* Rota para diagnóstico de conteúdos com "estatuto" */}
          <Route
            path={`${subDomain}/admin/diagnostico-conteudo-estatuto`}
            element={
              <ProtectedRoute>
                <DiagnosticoConteudoEstatuto />
              </ProtectedRoute>
            }
          />

          {/* Rota para diagnóstico de anexos */}
          <Route
            path={`${subDomain}/admin/diagnostico-anexos`}
            element={
              <ProtectedRoute>
                <DiagnosticoAnexos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de campos cancelado e desfiliado em praticantes */}
          <Route
            path={`${subDomain}/admin/migrar-cancelado-desfiliado`}
            element={
              <ProtectedRoute>
                <MigrarCamposCanceladoDesfiliado />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de campos cancelado e desfiliado em praticantes.view */}
          <Route
            path={`${subDomain}/admin/migrar-cancelado-desfiliado-view`}
            element={
              <ProtectedRoute>
                <MigrarCamposCanceladoDesfiliadoView />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração do campo exibirEmFiliados em praticantes.view */}
          <Route
            path={`${subDomain}/admin/migrar-exibir-filiados`}
            element={
              <ProtectedRoute>
                <MigrarCampoExibirEmFiliados />
              </ProtectedRoute>
            }
          />

          {/* Rota para Migração de metadados.desfiliado para novo formato */}
          <Route
            path={`${subDomain}/admin/migrar-metadados-desfiliado`}
            element={
              <ProtectedRoute>
                <MigrarMetadadosDesfiliado />
              </ProtectedRoute>
            }
          />

          {/* Rota para Sincronização de Nomes de Entidades em Praticantes */}
          <Route
            path={`${subDomain}/admin/sincronizar-nomes-entidades`}
            element={
              <ProtectedRoute>
                <SyncEntityNamesInPractitioners />
              </ProtectedRoute>
            }
          />

          {/* Rota para Rebuild da collection associacoes.view */}
          <Route
            path={`${subDomain}/admin/rebuild-associacoes-view`}
            element={
              <ProtectedRoute>
                <RebuildAssociacoesView />
              </ProtectedRoute>
            }
          />

          {/* Rota para Rebuild da collection entidades.view */}
          <Route
            path={`${subDomain}/admin/rebuild-entidades-view`}
            element={
              <ProtectedRoute>
                <RebuildEntidadesView />
              </ProtectedRoute>
            }
          />

          {/* Rota para Replicar Conteúdos CBTKD → Federações */}
          <Route
            path={`${subDomain}/admin/replicar-conteudos-federacoes`}
            element={
              <ProtectedRoute requiredPermission={9173}>
                <ReplicarConteudosFederacoes />
              </ProtectedRoute>
            }
          />

          {/* Rota para Reparar UF a partir da federação */}
          <Route
            path={`${subDomain}/admin/reparar-uf-praticantes`}
            element={
              <ProtectedRoute requiredPermission={9174}>
                <RepararUfPraticantesView />
              </ProtectedRoute>
            }
          />

          {/* Rota para Configurar cache de views públicas */}
          <Route
            path={`${subDomain}/admin/config-cache-views`}
            element={
              <ProtectedRoute requiredPermission={9175}>
                <ConfigCacheViewsView />
              </ProtectedRoute>
            }
          />

          {/* Auditoria de aceites do Termo de Uso e Política de Privacidade (GET/COB 94) */}
          <Route
            path={`${subDomain}/admin/auditoria-aceites-termos`}
            element={
              <ProtectedRoute requiredPermission={9191}>
                <AuditoriaAceitesTermos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Validar Nome de Entidade por ID */}
          <Route
            path={`${subDomain}/admin/validar-nome-entidade-por-id`}
            element={
              <ProtectedRoute>
                <ValidarNomeEntidadePorID />
              </ProtectedRoute>
            }
          />

          {/* Rota para Inspetor de Contas */}
          <Route
            path={`${subDomain}/admin/inspecionar-conta`}
            element={
              <ProtectedRoute requiredPermission={9044}>
                <InspecionarConta />
              </ProtectedRoute>
            }
          />

          {/* Rota para Consistência de Usuários por Portal e Grupo */}
          <Route
            path={`${subDomain}/admin/consistencia-usuarios-portal`}
            element={
              <ProtectedRoute requiredPermission={3118}>
                <ConsistenciaUsuariosPortalPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Sincronização de Nomes de Praticantes em Contas */}
          <Route
            path={`${subDomain}/admin/sync-praticante-names-contas`}
            element={
              <ProtectedRoute requiredPermission={3104}>
                <SyncPraticanteNamesInContas />
              </ProtectedRoute>
            }
          />

          {/* Rota para Batch Publicar Eventos (metadados.publicado) */}
          <Route
            path={`${subDomain}/admin/batch-publicar-eventos`}
            element={
              <ProtectedRoute requiredPermission={1663}>
                <BatchPublicarEventosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Exclusão de Importação (S7) */}
          <Route
            path={`${subDomain}/admin/excluir-importacao-evento`}
            element={
              <ProtectedRoute requiredPermission={1665}>
                <ExcluirImportacaoEvento />
              </ProtectedRoute>
            }
          />

          {/* Rota para Adicionar Campos database_origem e collection_origem */}
          <Route
            path={`${subDomain}/admin/add-database-origem-fields`}
            element={
              <ProtectedRoute requiredPermission={3111}>
                <AddDatabaseOrigemFields />
              </ProtectedRoute>
            }
          />

          {/* Rota para Criar Inscritos para Membros de Duplas/Equipes */}
          <Route
            path={`${subDomain}/admin/criar-inscritos-membros`}
            element={
              <ProtectedRoute requiredPermission={3112}>
                <CriarInscritosMembrosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Validação de Campos Boolean em Praticantes */}
          <Route
            path={`${subDomain}/admin/validar-campos-boolean-praticantes`}
            element={
              <ProtectedRoute>
                <ValidarCamposBooleanPraticantes />
              </ProtectedRoute>
            }
          />

          {/* Rota para Sincronizar Active por Anuidade 2025 */}
          <Route
            path={`${subDomain}/admin/sync-active-anuidade-2025`}
            element={
              <ProtectedRoute>
                <SyncActiveStatusByAnuidade2025 />
              </ProtectedRoute>
            }
          />

          {/* Rota para Ativação Federativa em Massa */}
          <Route
            path={`${subDomain}/admin/ativacao-federativa-massa`}
            element={
              <ProtectedRoute>
                <AtivacaoFederativaMassaPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Ativar Federativamente Graduações <= 9 */}
          <Route
            path={`${subDomain}/admin/ativar-federativamente-graduacoes`}
            element={
              <ProtectedRoute>
                <AtivarFederativamenteGraduacoesPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Corrigir Vinculações de Praticantes */}
          <Route
            path={`${subDomain}/admin/corrigir-vinculacoes-praticantes`}
            element={
              <ProtectedRoute>
                <CorrigirVinculacoesPraticantesPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Bloquear Praticantes com Cadastro Incompleto (sem UF) */}
          <Route
            path={`${subDomain}/admin/bloquear-praticantes-cadastro-incompleto`}
            element={
              <ProtectedRoute>
                <BloquearPraticantesCadastroIncompletoPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Recalcular MaxGraduacao em Lote */}
          <Route
            path={`${subDomain}/admin/recalcular-max-graduacao`}
            element={
              <ProtectedRoute requiredPermission={3202}>
                <RecalcularMaxGraduacaoPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Limpeza do campo historicoServicos (mapa legado) */}
          <Route
            path={`${subDomain}/admin/limpeza-historico-servicos`}
            element={
              <ProtectedRoute requiredPermission={3203}>
                <LimpezaHistoricoServicosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Duplicar Praticante + Usuário + Auth */}
          <Route
            path={`${subDomain}/admin/duplicar-praticante-usuario`}
            element={
              <ProtectedRoute requiredPermission={3204}>
                <DuplicarPraticanteUsuarioPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Restauração de Metadados em Praticantes */}
          <Route
            path={`${subDomain}/admin/restaurar-metadados-praticantes`}
            element={
              <ProtectedRoute>
                <RestoreMetadataInPractitioners />
              </ProtectedRoute>
            }
          />

          {/* Rota para Duplicação de Coleções (Backup) */}
          <Route
            path={`${subDomain}/admin/duplicar-colecao`}
            element={
              <ProtectedRoute>
                <DuplicarColecao />
              </ProtectedRoute>
            }
          />

          {/* Rota para Reorganizar Menus de Portais */}
          <Route
            path={`${subDomain}/admin/reorganizar-menus-portais`}
            element={
              <ProtectedRoute>
                <ReorganizarMenusPortais />
              </ProtectedRoute>
            }
          />

          {/* Rota para Transferir Praticantes entre Entidades */}
          <Route
            path={`${subDomain}/admin/transferir-praticantes`}
            element={
              <ProtectedRoute>
                <TransferirPraticantesPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Transferir Inscrições entre Eventos */}
          <Route
            path={`${subDomain}/admin/transferir-inscricoes-evento`}
            element={
              <ProtectedRoute>
                <TransferirInscricoesEvento />
              </ProtectedRoute>
            }
          />

          {/* Rota para Recuperar Inscrições de Inscritos */}
          <Route
            path={`${subDomain}/admin/recuperar-inscricoes-de-inscritos`}
            element={
              <ProtectedRoute>
                <RecuperarInscricoesDeInscritos />
              </ProtectedRoute>
            }
          />

          {/* Rota para Análise Comparativa Inscrições V2 vs V3 */}
          <Route
            path={`${subDomain}/admin/analisar-inscricoes-v2-vs-v3`}
            element={
              <ProtectedRoute>
                <AnalisarInscricoesV2VsV3 />
              </ProtectedRoute>
            }
          />

          {/* Rota para Teste InscricoesUnifiedService */}
          <Route
            path={`${subDomain}/admin/teste-inscricoes-unified`}
            element={
              <ProtectedRoute>
                <TesteInscricoesUnifiedPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Teste Integração POC Relatórios */}
          <Route
            path={`${subDomain}/admin/teste-integracao-relatorio`}
            element={
              <ProtectedRoute>
                <TesteIntegracaoRelatorioPage />
              </ProtectedRoute>
            }
          />

          {/* Rota para Extração de Registro Único */}
          <Route
            path={`${subDomain}/admin/extrair-registro-unico`}
            element={
              <ProtectedRoute>
                <ExtrairRegistroUnico />
              </ProtectedRoute>
            }
          />

          {/* Rota para Auditoria de Ações por Usuário */}
          <Route
            path={`${subDomain}/admin/auditoria-acoes-usuario`}
            element={
              <ProtectedRoute requiredPermission={3164}>
                <AuditoriaAcoesUsuario />
              </ProtectedRoute>
            }
          />

          {/* Rota para Diagnóstico de fontePagadoraSelecionada */}
          <Route
            path={`${subDomain}/admin/diagnostico-fonte-pagadora`}
            element={
              <ProtectedRoute>
                <DiagnosticoFontePagadora />
              </ProtectedRoute>
            }
          />

          {/* Rota para Diagnóstico de Contas Duplicadas */}
          <Route
            path={`${subDomain}/admin/diagnostico-contas-duplicadas`}
            element={
              <ProtectedRoute>
                <DiagnosticoContasDuplicadas />
              </ProtectedRoute>
            }
          />

          {/* Rota para Monitor de Certificados */}
          <Route
            path={`${subDomain}/admin/certificados-monitor`}
            element={
              <ProtectedRoute requiredPermission={2511}>
                <CertificadosQueueMonitor />
              </ProtectedRoute>
            }
          />

          {/* Rota para Configuração de Certificados */}
          <Route
            path={`${subDomain}/admin/certificados-config`}
            element={
              <ProtectedRoute>
                <CertificateConfigurationManager />
              </ProtectedRoute>
            }
          />

          {/* Rota para Configuração de Certificados V2 */}
          <Route
            path={`${subDomain}/admin/certificados-config-v2`}
            element={
              <ProtectedRoute requiredPermission={2513}>
                <CertificateConfigurationManagerV2 />
              </ProtectedRoute>
            }
          />

          {/* Rota para Painel Administrativo de Certificados */}
          <Route
            path={`${subDomain}/admin/certificados-painel`}
            element={
              <ProtectedRoute>
                <AdminCertificadosPanel />
              </ProtectedRoute>
            }
          />

          {/* Rota para Dashboard de Monitoramento de Produção */}
          <Route
            path={`${subDomain}/admin/production-dashboard`}
            element={
              <ProtectedRoute>
                <ProductionDashboard />
              </ProtectedRoute>
            }
          />

          {/* Rota para Painel Administrativo Geral */}
          <Route
            path={`${subDomain}/admin`}
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />

          {/* ===== ROTAS DO MÓDULO COLETES (HOGU) ===== */}
          <Route
            path={`${subDomain}/admin/coletes/referencias`}
            element={
              <ProtectedRoute>
                <ColetesReferenciasPage />
              </ProtectedRoute>
            }
          />

          {/* ===== ROTAS DO MÓDULO NOTIFICAÇÕES ===== */}
          
          {/* Lista de Notificações */}
          <Route
            path={`${subDomain}/admin/notifications`}
            element={
              <ProtectedRoute>
                <NotificationsListPage />
              </ProtectedRoute>
            }
          />

          {/* Dashboard de Notificações */}
          <Route
            path={`${subDomain}/admin/notifications/dashboard`}
            element={
              <ProtectedRoute>
                <NotificationsDashboardPage />
              </ProtectedRoute>
            }
          />

          {/* Fila de Aprovação */}
          <Route
            path={`${subDomain}/admin/notifications/approval-queue`}
            element={
              <ProtectedRoute>
                <ApprovalQueuePage />
              </ProtectedRoute>
            }
          />

          {/* Grupos de Notificação */}
          <Route
            path={`${subDomain}/admin/notifications/groups`}
            element={
              <ProtectedRoute>
                <NotificationGroupsPage />
              </ProtectedRoute>
            }
          />

          {/* Configuração de Rate Limits */}
          <Route
            path={`${subDomain}/admin/notifications/rate-limits`}
            element={
              <ProtectedRoute>
                <RateLimitsConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Criar Nova Notificação */}
          <Route
            path={`${subDomain}/admin/notifications/create`}
            element={
              <ProtectedRoute>
                <CreateNotificationPage />
              </ProtectedRoute>
            }
          />

          {/* ===== FIM ROTAS NOTIFICAÇÕES ===== */}

          {/* Rota para Visualizador de Logs do Sistema */}
          <Route
            path={`${subDomain}/admin/console-logs`}
            element={
              <ProtectedRoute>
                <ConsoleLogViewer />
              </ProtectedRoute>
            }
          />

          {/* Rota para Limpeza de Cache - Desenvolvimento apenas */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/clear-cache`}
            element={
              <div style={{width: '100%', height: '100vh'}}>
                <iframe 
                  src="/clear-cache.html" 
                  style={{width: '100%', height: '100%', border: 'none'}}
                  title="Limpeza de Cache"
                />
              </div>
            }
          />
          )}

          {/* Rota para Manutenção Simplificada (sem recursos externos) - Desenvolvimento apenas */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/manutencao-simplificada`}
            element={<ManutencaoSimplificada />}
          />
          )}

          {/* Rota para Manutenção de Conteúdos dos Portais - Desenvolvimento apenas */}
          {import.meta.env.MODE === 'development' && (
          <Route
            path={`${subDomain}/admin/manutencao-conteudos-portais`}
            element={
              <ProtectedRoute>
                <ManutencaoConteudosPortais />
              </ProtectedRoute>
            }
          />
          )}

          {/* Rota para Correção de URLs da Coleção Portias */}
          <Route
            path={`${subDomain}/admin/fix-portias-urls`}
            element={
              <ProtectedRoute>
                <FixPortiasUrls />
              </ProtectedRoute>
            }
          />

          {/* ===== SUPORTE VIA IA (Assistente Tae) ===== */}
          <Route
            path={`${subDomain}/suporte-ia`}
            element={
              <ProtectedRoute>
                <AIAssistantPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`${subDomain}/admin/chat-ai`}
            element={
              <ProtectedRoute>
                <ChatAIAdminPage />
              </ProtectedRoute>
            }
          />

          {/* Base de conhecimento do Assistente Tae */}
          <Route
            path={`${subDomain}/admin/chat-ai-documentos`}
            element={
              <ProtectedRoute requiredPermission={9310}>
                <ChatAIDocumentManager />
              </ProtectedRoute>
            }
          />

          {/* ===== MÓDULO POOMSAE (legado) DESATIVADO em 27/09/2026 =====
              O Poomsae passa a ser produto separado (poomsae-app). Módulo antigo em
              disabled/poomsae-modulo-legado/ — ver docs/poomsae/DESATIVACAO-MODULO-LEGADO.md */}

          {/* <Route path={`${subDomain}/394857`} element={<Navigate to="/public/394857/" />} /> */}
          <Route path={`${subDomain}/kukkiwon`} element={<Navigate to="/public/kukkiwon/" />} />

          <Route path={`${subDomain}/notverified`} element={<NotVerifiedPage />} />
          <Route path={`${subDomain}/unauthorized`} element={<UnauthorizedPage />} />
          {/* Módulo desligado no portal (CRM, Certificados de Faixas Coloridas). */}
          <Route path={`${subDomain}/modulo-indisponivel`} element={<ModuloIndisponivelPage />} />
          <Route path={`${subDomain}*`} element={<NotFoundPage />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}
